// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vd__1eYLu","header":"vd__3LqXg","open":"vd__23FkQ","content":"vd__20piK"};